import React from 'react'
import Table from 'react-bootstrap/Table'
import moment from "moment"

const MarkerTable = (props) => {

    return (
        <>
            {props.markers && props.markers.length
                ? <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Category</th>
                            <th>Title</th>
                            <th>Created at</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.markers
                            .map(marker => (
                                <tr key={marker.id}>
                                    <td>
                                        {marker.id}
                                    </td>
                                    <td>
                                        {marker.category}
                                    </td>
                                    <td>
                                        {marker.title}
                                    </td>
                                    <td>
                                        {moment(marker.createdAt).format('YYYY-MM-DD HH:mm')}
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                  </Table>
                : <>
                    No marks added yet.
                  </>
            }
        </>
    )
}

export default MarkerTable